var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 36,
    viewBox: "0 0 31 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_842_1748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.399109 15.6938L4.02521 18.2531L4.00559 15.3L0.399109 15.6938Z",
    fill: "#BA1E2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6 8.92236V34.2913C30.6 35.2353 29.8188 36 28.8554 36H5.76977C4.80636 36 4.02521 35.2353 4.02521 34.2913V1.70901C4.02521 0.765073 4.80636 0 5.76977 0H20.8552L30.6 8.92236V8.92236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3247 7.16479H0.723722C0.324021 7.16479 0 7.48215 0 7.87362V15.0604C0 15.4519 0.324021 15.7692 0.723722 15.7692H17.3247C17.7244 15.7692 18.0485 15.4519 18.0485 15.0604V7.87362C18.0485 7.48215 17.7244 7.16479 17.3247 7.16479Z",
    fill: "#ED1B24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.02117 14.0801V9.08374H4.62805C4.90877 9.08374 5.17022 9.10924 5.41206 9.16025C5.65389 9.21125 5.86327 9.29789 6.03983 9.41981C6.21639 9.54209 6.35443 9.70139 6.45323 9.89737C6.55203 10.0934 6.60161 10.3365 6.60161 10.6268C6.60161 10.9017 6.55203 11.1414 6.45323 11.3451C6.35443 11.5487 6.21782 11.7182 6.04375 11.853C5.86933 11.9879 5.66424 12.0874 5.42739 12.151C5.19055 12.2146 4.93481 12.2464 4.65909 12.2464H3.92573V14.0798H3.02081L3.02117 14.0801ZM3.92609 11.5362H4.58917C5.33787 11.5362 5.71239 11.2333 5.71239 10.6272C5.71239 10.3114 5.61501 10.0937 5.4199 9.97388C5.22479 9.8544 4.93766 9.79431 4.55814 9.79431H3.92645V11.5362H3.92609Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.56073 14.0801V9.08374H8.92578C9.70586 9.08374 10.3144 9.28986 10.751 9.70244C11.1879 10.115 11.4062 10.7337 11.4062 11.5589C11.4062 11.9715 11.3502 12.3355 11.2386 12.6513C11.1265 12.9671 10.9657 13.2309 10.7549 13.4419C10.5444 13.6532 10.2894 13.8125 9.9905 13.9194C9.69123 14.0263 9.35202 14.0798 8.97251 14.0798H7.56073V14.0801ZM8.46565 13.3619H8.86336C9.38341 13.3619 9.78255 13.2155 10.0608 12.9227C10.339 12.63 10.4781 12.1755 10.4781 11.5592C10.4781 10.943 10.3376 10.5024 10.0568 10.2223C9.77613 9.94209 9.37842 9.802 8.86336 9.802H8.46565V13.3619V13.3619Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.436 14.0801V9.08374H15.5171V9.83239H13.3409V11.2459H15.1975V11.9945H13.3409V14.0801H12.436V14.0801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6 8.92236V9.18646H21.9185C21.2558 9.18646 20.7183 8.66 20.7183 8.01056V0H20.8552L30.6 8.92236V8.92236Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6873 18.5474H8.93829V19.9615H25.6873V18.5474Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6873 21.8062H8.93829V23.2203H25.6873V21.8062Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6873 25.0647H8.93829V26.4789H25.6873V25.0647Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6873 28.3235H8.93829V29.7376H25.6873V28.3235Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6873 31.5823H8.93829V32.9964H25.6873V31.5823Z",
    fill: "#E6E7E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_842_1748"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.6,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfMessage);
export default __webpack_public_path__ + "static/media/pdf_message.83945e9384f929663a5cb8341a85e171.svg";
export { ForwardRef as ReactComponent };